import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import authEpic from "@/features/auth/duck/authEpic";
import propertyEpic from "@/features/property/duck/propertyEpic";
import userEpic from "@/features/user/duck/userEpic";
import inboxEpic from "@/features/user/duck/inboxEpic";
import dashboardEpic from "@/features/dashboard/duck/dashboardEpic";
import subscriptionEpic from "@/features/property/duck/subscriptionEpic";
import marketInsightsEpic from "@/features/marketInsights/duck/marketInsightsEpic";
import userSubscriptionEpic from "@/features/user/duck/userSubscriptionEpic";
import aiChatBotEpic from "@/features/aiAgentChatBot/duck/aiChatBotEpic";

export default (...args) =>
  combineEpics(
    authEpic,
    propertyEpic,
    userEpic,
    inboxEpic,
    dashboardEpic,
    subscriptionEpic,
    marketInsightsEpic,
    userSubscriptionEpic,
    aiChatBotEpic
  )(...args, { Observable });
